import { LEGEND_SWATCH_WIDTH } from './legend-swatch.constants';

/**
 * Dash patterns are absolute pixels sized for a chart line spanning the whole
 * plot area, so a swatch that starts the pattern at x=0 shows one full dash and
 * then a clipped stub -- a long dash ends up reading as a solid line. Offsetting
 * the pattern so that its middle element lands in the middle of the swatch puts
 * a mark on either side of that centre instead: the gap of a `dash gap` pattern,
 * or the dot of a `dash gap dot gap` one, which is what makes a dash-dot row
 * read as dash-dot-dash rather than as an arbitrary slice of the pattern.
 */
export function legendSwatchDashoffset(
  svgDasharray: string | undefined,
  swatchWidth: number = LEGEND_SWATCH_WIDTH
): number | null {
  if (!svgDasharray || svgDasharray === 'none') {
    return null;
  }

  const lengths = svgDasharray
    .split(/[\s,]+/)
    .map((part) => Number.parseFloat(part))
    .filter((length) => Number.isFinite(length));
  if (!lengths.length) {
    return null;
  }

  // A single-value dasharray means dash and gap are the same length.
  const pattern = lengths.length === 1 ? [lengths[0], lengths[0]] : lengths;
  const middle = Math.floor(pattern.length / 2);
  const beforeMiddle = pattern
    .slice(0, middle)
    .reduce((total, length) => total + length, 0);

  return beforeMiddle + pattern[middle] / 2 - swatchWidth / 2;
}
